"use client";

import { ArrowLeft } from "lucide-react";
import { motion } from "framer-motion";
import { useTranslations } from "@frontend/lib/next-intl-typed";
import { useRouter } from "next/navigation";
import {
  useInsuranceConnectorContext,
  useInsuranceConnectorSend,
} from "../insurance-connector-provider";

export function WorkplaceInjuryQuestion() {
  const t = useTranslations("InsuranceConnector");
  const context = useInsuranceConnectorContext();
  const send = useInsuranceConnectorSend();
  const router = useRouter();

  const { workplaceInjuryRoutes } = context;
  if (!workplaceInjuryRoutes?.yesRoute || !workplaceInjuryRoutes?.noRoute) {
    throw new Error(
      "WorkplaceInjuryQuestion: workplaceInjuryRoutes is not configured. " +
        "Ensure the org input provides both yesRoute and noRoute.",
    );
  }

  return (
    <div className="p-0 pt-2 md:p-6 flex flex-col justify-between h-full">
      <div className="flex h-full">
        <h2 className="text-2xl md:text-3xl font-bold">
          {t("WorkplaceInjuryTitle")}
        </h2>
      </div>

      <div className="flex justify-end md:justify-between items-center pt-3 md:pt-0">
        <motion.button
          type="button"
          onClick={() => send({ type: "BACK" })}
          className="hidden md:flex border border-black rounded-full aspect-square w-12 h-12 items-center justify-center"
          aria-label={t("GoBack")}
          initial={{ backgroundColor: "transparent", color: "#000000" }}
          whileHover={{ backgroundColor: "#000000", color: "#ffffff" }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
        >
          <ArrowLeft className="h-5 w-5" />
        </motion.button>

        <div className="flex gap-3">
          <motion.button
            type="button"
            onClick={() => {
              send({ type: "CLOSE" });
              router.push(`/${workplaceInjuryRoutes.noRoute}`);
            }}
            className="inline-flex items-center justify-center rounded-full px-[53px] md:px-[48px] py-5 md:py-[20px] text-base md:text-xl font-medium border border-black/40"
            data-testid="workplace-injury-no"
            initial={{ backgroundColor: "transparent", color: "#000000" }}
            whileHover={{ backgroundColor: "#000000", color: "#ffffff" }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
          >
            {t("No")}
          </motion.button>
          <motion.button
            type="button"
            onClick={() => {
              send({ type: "CLOSE" });
              router.push(`/${workplaceInjuryRoutes.yesRoute}`);
            }}
            className="inline-flex items-center justify-center rounded-full px-[53px] md:px-[48px] py-5 md:py-[20px] text-base md:text-xl font-medium text-white"
            data-testid="workplace-injury-yes"
            initial={{ backgroundColor: "#000000" }}
            whileHover={{ backgroundColor: "#00A3FF" }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
          >
            {t("Yes")}
          </motion.button>
        </div>
      </div>
    </div>
  );
}
